// @ts-ignore
/* eslint-disable */
import { request } from '../../request'

/** No comments are provided by the backend GET /projects/${param0}/export */
export async function exportControllerExport(
  // Param type generated by superposition
  params: API.ExportControllerExportParams,
  options?: { [key: string]: any },
) {
  const { projectId: param0, ...queryParams } = params
  return request<any>(`/projects/${param0}/export`, {
    method: 'GET',
    params: {
      ...queryParams,
    },
    ...(options || {}),
  })
}
